import { match } from "ts-pattern";
import ImageMediaModal from "./ImageMediaModal";
import VideoMediaModal from "./VideoMediaModal";
import MediaResponseResource from "common/resources/Project/Config/Media/MediaResponseResource";
import { EMediaKind } from "common/enums/Project/Config/Media/EMediaKind";

type IProps = {
	media: MediaResponseResource;
	isOpen: boolean;
	onClose: () => void;
};

export default function MediaModal(props: IProps) {
	return match(props.media.kind)
		.with(EMediaKind.VIDEO, () => <VideoMediaModal {...props} />)
		.with(EMediaKind.IMAGE, () => <ImageMediaModal {...props} />)
		.with(EMediaKind.URL, () => <></>)
		.exhaustive();
}
